import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface UsersByCustomerRequestParams {
  Carrierkey: number;
}

export const getShipmentRoutingUsersAPI = (params: UsersByCustomerRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentRoutingUsers`,
    method: 'get',
    params,
  });
};

export type ShipmentRoutingUsersResponse = {
  disabled: boolean;
  group: null;
  selected: boolean;
  text: string;
  value: string; // '999'
}[];

export const fetchShipmentRoutingUsersList = async (
  params: UsersByCustomerRequestParams,
): Promise<ShipmentRoutingUsersResponse> => {
  const response: AxiosResponse<ShipmentRoutingUsersResponse> = await getShipmentRoutingUsersAPI(params);
  return response.data;
};
